import { toast } from 'sonner';
import { useMutation } from '@apollo/client/react';

import { CompanyDocument, ICompanyQuery } from 'src/graphql/actions/company/company.query';
import { UpdateCompanyDocument } from 'src/graphql/actions/company/updateCompany.mutation';
import { ClientError, getApiError } from 'src/utils/errors';
import { apolloClient as client } from 'src/graphql';
import {
  OrganizationForm,
  OrganizationRegistrationNumberTooltip,
  type IOrganizationForm,
} from '@/components/Organization';

type Props = {
  onCancel?: () => void;
  successCallback?: () => void;
  classes?: {
    footer?: string;
    form?: string;
    submitBtn?: string;
  };
  submitBtnText?: string | React.ReactNode;
  withCard?: boolean;
};

const OrganizationFormContainer = ({ onCancel, successCallback, classes, submitBtnText = 'Save', withCard }: Props) => {
  const data = client.readQuery<ICompanyQuery>({
    query: CompanyDocument,
  });
  const [updateCompany] = useMutation(UpdateCompanyDocument);

  const defaultValues: IOrganizationForm = {
    companyName: data?.company.companyName || '',
    street: data?.company.street || '',
    streetNumber: data?.company.streetNumber || '',
    city: data?.company.city || '',
    postalCode: data?.company.postalCode || '',
    country: data?.company.country || '',
    region: data?.company.region || '',
    companyWebsite: data?.company.companyWebsite || '',
    companyRegistration: data?.company.companyRegistration || '',
  };

  async function onSubmit(dataForm: IOrganizationForm) {
    try {
      const { data } = await updateCompany({
        variables: {
          companyInput: dataForm,
        },
      });
      if (data?.updateCompany?.success) {
        toast.success('Details updated!');
        successCallback?.();
      } else {
        throw new ClientError('Something went wrong');
      }
    } catch (error) {
      getApiError(error, toast.error);
    }
  }

  return (
    <OrganizationForm
      onCancel={onCancel}
      classes={classes}
      submitBtnText={submitBtnText}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      registrationTooltip={<OrganizationRegistrationNumberTooltip />}
      withCard={withCard}
    />
  );
};

export default OrganizationFormContainer;
